import { render, staticRenderFns } from "./createPaymentMethod.vue?vue&type=template&id=1f68147f&scoped=true&"
import script from "./createPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./createPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./createPaymentMethod.vue?vue&type=style&index=0&id=1f68147f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68147f",
  null
  
)

export default component.exports